import { GridColDef } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import styled from "styled-components";

import DataTable from "../DashboardTable";
import { HitsArr } from "../../../types/types";

type Props = {
  filteredData: HitsArr[];
};

const countryColumns: GridColDef[] = [
  { field: "id", headerName: "Challenge ID", width: 300 },
  { field: "@timestamp", headerName: "Timestamp", width: 200 },
  { field: "time_for_solving", headerName: "Solving time", width: 200 },
  { field: "solution_weight", headerName: "Solution weight", width: 200 },
];

const SixthGroup = ({ filteredData }: Props) => {
  const data =
    filteredData?.map((item) => {
      return {
        id: item._source.challenge_id,
        "@timestamp": item._source["@timestamp"],
        time_for_solving: item._source.time_for_solving,
        solution_weight: item._source.solution_weight,
      };
    }) || [];

  // const dataLength = filteredData?.length;

  return (
    <SixthCharts>
      <DataTable columns={countryColumns} rows={data} />
    </SixthCharts>
  );
};

export default SixthGroup;

const SixthCharts = styled.div`
  display: flex;
  gap: 10px;
`;

